export default function doesThisRouteTargetThisScreen(route, screen, params){
	return route && route.name === screen &&
		JSON.stringify(route.params || {}) === JSON.stringify(params || {});
}
